<!--
 * @Author: Merlin
 * @Date: 2024-03-11 09:59:25
 * @LastEditors: Merlin
 * @LastEditTime: 2024-07-15 13:28:46
 * @Description: 
-->
<template>
    <!-- ↓图标列 -->
    <!-- <CasinoHistoryHeaderCell
        :text="t.Game.toUpperCase()"
        class="md:flex-[0.6]"
    /> -->
    <!--
        💎💎💎
        重要说明：以上列在 Mini 版中被废弃了
        暂时注释，将来删除 2024.06.21 16:50:27 星期五 
    -->
    <!-- ↓时间列 -->
    <CasinoHistoryHeaderCell
        :text="t.Time.toUpperCase()" 
    />
    <!-- ↓下注金额 -->
    <CasinoHistoryHeaderCell
        :text="t.BetAmount.toUpperCase()"
        class="flex-[0.9]"
    />
    <!-- ↓倍数 -->
    <CasinoHistoryHeaderCell
        class="flex-[0_1_78px]"
        :text="t.Multiplier.toUpperCase()"
    />
    <!-- ↓提现金额列 -->
    <CasinoHistoryHeaderCell
        class="flex-1 !pr-0"
        :text="t.Payout.toUpperCase()"
    />
</template>

<script setup lang="ts">
import useTranslation from '~/i18n/useTransLation';

const t = useTranslation();
const props = defineProps({
    isMobileMode: Boolean, // 声明出来，否则控制台一直打印 warn 信息 
});

</script>
